import React from "react";
import { Rows3, Rows2, LayoutGrid, Grid3x3 } from "lucide-react";
import styles from "./ViewSwitcher.module.scss";

/**
 * 4 modlu görünüm seçici — liste sayfaları için.
 *
 *   "list-1" → tek satır liste (kompakt tablo)
 *   "list-2" → 2 sütun liste (kompakt, mobil-friendly)
 *   "grid-3" → 3 sütun kart
 *   "grid-4" → 4 sütun kart
 *
 * Token-driven; segmented icon-only kontrol. Klavye/ARIA tablist.
 *
 * <ViewSwitcher value={mode} onChange={setMode} modes={["list-1","grid-3"]} />
 *
 * `modes` opsiyonel — sayfaya göre alt küme seçmek için (örn. Tasks: tüm 4,
 * Reports: yalnızca "list-1"). Default 4 mod.
 */
const MODES = [
  { value: "list-1", icon: Rows3,     label: "Liste" },
  { value: "list-2", icon: Rows2,     label: "İkili liste" },
  { value: "grid-3", icon: LayoutGrid, label: "Üçlü kart" },
  { value: "grid-4", icon: Grid3x3,   label: "Dörtlü kart" },
];

const ViewSwitcher = ({ value, onChange, modes, ariaLabel = "Görünüm" }) => {
  const visible = modes ? MODES.filter((m) => modes.includes(m.value)) : MODES;

  return (
    <div className={styles.segment} role="tablist" aria-label={ariaLabel}>
      {visible.map(({ value: v, icon: Icon, label }) => (
        <button
          key={v}
          type="button"
          role="tab"
          aria-selected={value === v}
          aria-label={label}
          title={label}
          className={styles.button}
          data-active={value === v || undefined}
          onClick={() => onChange?.(v)}
        >
          <Icon size={16} strokeWidth={2} aria-hidden />
        </button>
      ))}
    </div>
  );
};

export default ViewSwitcher;
export { MODES as VIEW_MODES };
